import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(1),
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      alignItems: "left",
      marginTop: theme.spacing(2),
    },
    justifyContent: "space-between",
  },
  titleContainer: {
    cursor: "pointer",
    zIndex: "10",
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2),
    },
  },
  instructorsContainer: {
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
      marginBottom: theme.spacing(2),
    },
  },
  buttonLabel: {
    color: theme.palette.primary.main,
  },
  nameText: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
    wordBreak: "break-word",
  },
  paperRow: {
    border: "1px solid #E2E2E2",
    borderRadius: "4px",
    marginBottom: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  greenChip: {
    borderRadius: "4px",
    fontSize: "11px",
    fontWeight: "600",
    color: "#29B117",
    backgroundColor: "#D3EFCF",
  },
  redChip: {
    borderRadius: "4px",
    fontSize: "11px",
    fontWeight: "600",
    color: "#f44336",
    backgroundColor: "#FFDBC5",
  },
}))

export default styles
